import { use_slice_collections, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_collections from '@/locales/keys/i18n_page_collections.json';
import { ButtonComponentActionEmpty } from '@/pages/_base/buttons/ButtonComponentActionEmpty';
import { ButtonWorkspaceChildEntityShare } from '@/pages/_base/buttons/ButtonWorkspaceChildEntityShare';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { set_collection_current } from '@/utils/utils_client_workspace_child_entity_viewers';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { FunctionComponent, SVGProps, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  entity: DTO__collection;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
}

export function C_LIST_ITEM__collection_special({ entity, Icon }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_COLLECTIONS);

  const { collection_current } = use_slice_collections(['collection_current']);
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  const [isHovered, setIsHovered] = useState(false);
  /*
   * EVENTS
   */
  function onClick() {
    set_collection_current(entity._id);
  }

  /*
   * METHODS
   */

  function is_selected() {
    return collection_current._id == entity._id && !collection_current.is_stub();
  }

  /*
   * RENDERS
   */
  function render_button_share() {
    let out = null;
    if (isHovered || entity.is_shared || global_is_mobile) {
      out = (
        <>
          <ButtonComponentActionEmpty />
          <ButtonWorkspaceChildEntityShare
            isSelected={is_selected() || isHovered}
            item={entity}
            required_permission={ENUM__workspace_entity_feature.ENTITY_COLLECTION_SHARE}
          />
          <ButtonComponentActionEmpty />
        </>
      );
    }

    return <div className="flex flex-row items-center justify-center gap-1">{out}</div>;
  }

  /*
   * HTML
   */
  if (entity.is_stub()) return <></>;

  return (
    <div
      className={`list-item-wrapper px-2  
        ${entity.is_hidden ? 'opacity-50' : ''}
        
        
        `}
      {...{ onClick }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`list-item-inner hover-animation px-2   ${isHovered || is_selected() ? 'list-item-selected' : ''}`}>
        <div className="flex items-center justyfy-start gap-2 w-full truncate">
          <Icon className={`w-4 h-4  ${isHovered || is_selected() ? 'text-component' : ' text-component-item-foreground'} `} />
          {t(i18n_page_collections.collections_special[entity.type])}
        </div>
        {render_button_share()}
      </div>
    </div>
  );
}
